export const columns = [
  {
    title: "#",
    dataIndex: "index",
    width: 60,
    slots: { customRender: "index" },
  },
  {
    title: "清单编号",
    width: 180,
    key: "bizNo",
    dataIndex: "bizNo",
  },
  {
    title: "清单名称",
    width: 150,
    key: "name",
    dataIndex: "name",
  },
  {
    title: "项目特征",
    width: 200,
    key: "feature",
    dataIndex: "feature",
  },
  {
    title: "结算单位",
    width: 150,
    key: "unit",
    dataIndex: "unit",
  },
  {
    title: "工程量",
    width: 150,
    key: "count",
    dataIndex: "count",
  },
  {
    title: "综合单价（￥）",
    width: 150,
    key: "price",
    dataIndex: "price",
  },
];
